export enum StatusAppointment {
  INAPPOINTMENT = 'inAppointment',
  ENDING = 'ending',
  CANCELED = 'canceled',
  WROTE = 'wrote'
}

export const StatusAppointmentTitles = {
  [StatusAppointment.ENDING]: 'Прием окончен',
  [StatusAppointment.INAPPOINTMENT]: 'На приеме',
  [StatusAppointment.WROTE]: 'Записан',
  [StatusAppointment.CANCELED]: 'Отменен'
}
